export default __webpack_public_path__ + "static/media/Arquivo_de_Pedidos.7eebbdd1.svg";